import React, { memo } from 'react';

/**
 * Confirmation modal shown when user edits filters on a saved screener.
 * Options: Cancel, Apply Without Saving, Save as New.
 */
const FilterUpdateConfirmModal = memo(({ onCancel, onApplyWithoutSaving, onSaveAsNew }) => (
  <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
    <div className="bg-white rounded-xl w-[90%] max-w-md overflow-hidden shadow-xl">
      {/* Header */}
      <div className="flex justify-between items-center px-6 py-5 border-b border-slate-200">
        <h3 className="m-0 text-lg font-semibold text-gray-900">Update Filters</h3>
        <button
          className="bg-transparent border-none text-xl cursor-pointer text-slate-500 p-1 hover:text-slate-700"
          onClick={onCancel}
        >
          ✕
        </button>
      </div>

      {/* Body */}
      <div className="p-6">
        <p className="text-sm text-slate-600 mb-2">
          You are viewing a saved screener. Do you want to save these filters as a new screener?
        </p>
        <p className="text-xs text-slate-500">The existing screener will not be modified.</p>
      </div>

      {/* Footer */}
      <div className="flex justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50">
        <button
          className="px-4 py-2.5 bg-white text-slate-700 border border-slate-200 rounded-md cursor-pointer text-sm hover:bg-slate-50 transition-colors duration-150"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          className="px-4 py-2.5 bg-slate-100 text-slate-700 border border-slate-200 rounded-md cursor-pointer text-sm hover:bg-slate-200 transition-colors duration-150"
          onClick={onApplyWithoutSaving}
        >
          Apply Without Saving
        </button>
        <button
          className="px-5 py-2.5 bg-amber-100 text-amber-800 border border-slate-400 rounded-md cursor-pointer text-sm font-medium hover:bg-[#474747] transition-colors duration-150"
          onClick={onSaveAsNew}
        >
          Save as New
        </button>
      </div>
    </div>
  </div>
));

FilterUpdateConfirmModal.displayName = 'FilterUpdateConfirmModal';

export default FilterUpdateConfirmModal;
